import src from "IMAGE";
export default { src, width: 1517, height: 796, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAASUlEQVR42oWNsQ2AUAgF2X8ZrW3U+ANCYAY7rKgc4JmwwL/mkmuOMIHW68Nxv4gImBlEBGOMdmaCli2xn08HZoa7Q1XbVQWaLX5sN3YyXmk7kAAAAABJRU5ErkJggg=="};
